export const clipsPreviewVideoJsOptions = {
  id: 'publish-preview-player',
  liveui: true,
  autoplay: false,
  preload: 'metadata' as 'auto' | 'metadata' | 'none',
  errorDisplay: false,
  loop: false,
  playbackRates: [0.5, 1, 1.5, 2, 5],
};
